import { createAction } from 'redux-actions'

const ENTITY = 'FORM_FILTERS'
export const stateKey = 'formFilters'

export const setFormFilter = createAction(`${ENTITY}/SET_FILTER`)
export const resetFormFilters = createAction(`${ENTITY}/RESET`)
